// extracted by mini-css-extract-plugin
export var section = "content-module--section--fGwcz";
export var categoriesList = "content-module--categoriesList--2ieLg";
export var categoryName = "content-module--categoryName--2NM4s";
export var disable = "content-module--disable--3MM8l";